import { message } from 'antd'
import request from '../../utils/request'
import ModalConfirm from '../modal/modalConfirm'

const Delete = (props) => {
  const { params, onDelete } = props
  const deleteColl = async () => {
    try {
      const res = await request.get('ins/inspiration/delete-inspiration', { params })
      if (res) {
        message.success('删除成功')
        onDelete && onDelete()
      }
    } catch (err) {
      console.error(err)
    }
  }
  ModalConfirm.show({ title: '确认删除灵感集？', content: '当灵感集删除后，其下内容将一并删除，在回收站保留30天，超过30天将无法恢复。', onOk: () => deleteColl(), wrapStyle: { zIndex: '1001' } })
}

export default Delete
